import { lazyGettext } from '@eb/i18n-ebspa';

export const CARD_FADE_DELAY = 500;
export const FOLLOW_CTA = lazyGettext('Follow');
export const ORGANIZER_IMAGE_DIAMETER = '80px';
